import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import DataLoader from "../../../../ui/template/Data/DataLoader";
import Child from "../../../../ui/template/Children/Child";
import AppConfig from "../../../Controllers/AppConfig";
import CommentInsert from "./CommentInsert";
import PropTypes from "prop-types";
import Likes from "./Likes";


class   Comments  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.id=props.topicId;
        this.queryArgs = "topicId:"+this.id+",";

        this.routPost1="topicComment"+this.id;
        this.rowsId=0;
        this.HfunCV=this.funCV.bind(this);
        this.LikesEl=React.createRef();
        this.props=props;
    }

    funCV(data,ts,recordKey,selectFun=null){
        let rows=[];
        let l=data.length;
        let s1="";
        for (let i=0;i<l;i++){
            this.rowsId++;
            s1='http://mdyaran.ir/membership/'+data[i].membershipId+'/picture';
            let el=   <div  key={this.rowsId} className="p-3 d-flex align-items-top border-bottom osahan-post-comment">
                            <div className="dropdown-list-image mr-3">
                                <img  src="/images/avatar.jpg" data-src={s1}  className="lazyload blur-up img-fluid mt-2 rounded-circle mw150"/>
                                <div className="status-indicator bg-success" />
                            </div>
                            <div className="font-weight-bold d-block w-100">
                                <div className="text-truncate"> {data[i].usernameMember}
                                    <span className="float-right small">{data[i].createdAt} </span></div>
                                <div className="small text-gray-500 pt-2 line-h-2 font-9">{data[i].textComment}</div>
                            </div>
                        </div>   ;
            rows.push(el);
        }
        ts.cv=<><div className="mb-4">{rows}</div> </>;
        this.LikesEl.current.setNumberComments(ts.totalNumber);
    }



   

    render() {

        return (
            <>
                <Likes ref={this.LikesEl} topicId={this.props.topicId} />
                <DataLoader ref={this.table1} scope="route" name={this.routPost1} classNameLoader="dataloader1"
                            baseUrl={AppConfig.base_url} orderColumn={5} orderDir={2}  queryArgs={this.queryArgs}
                            srcName="topicComment" getBoxItem={ this.HgetBoxItem} selectable={false}
                            funCustomVeiw={ this.HfunCV} isCustomVeiw={true} className="" isHeader={false}
                            queryFields="id,state,createdAt,textComment,usernameMember,membershipId">
                    <Child type="navbar">

                    </Child>
                    <Child type="links">

                    </Child>
                </DataLoader>
                <CommentInsert topicId={this.props.topicId} />
                    </>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Comments.contextType = MCbrowser;

Comments.propTypes = {
    topicId:PropTypes.string,
};

export default Comments;
